import { useParams } from "react-router-dom";
import { MainContainer } from "../Components/MainContainer";
import { useEffect, useState } from "react";
import { Api } from "../Services/CohortServices";
import { TCohort } from "../Types/CohortType";
import { BuildView } from "./CreateCohort";



export const CohortUpdate = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [cohort, setCohort] = useState<TCohort>();


  const fetchCohort = async () => {
    setLoading(true)
    try {
      const response = await Api.get(`/cohorts/${id}`); 
      setCohort(response.data.cohort);

    } catch (error) {
      setError("Não houve retorno do servidor, tente novamente mais tarde.");
    }
    finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    const controller = new AbortController();
    fetchCohort();
    return () => {
      controller.abort();
    };
    //eslint-disable-next-line
  }, [])

  return (
    <MainContainer>
      <>
        {loading ? (
          <p className="d-flex align-items-center mt-4">Carregando...</p>
        ) : error ? (
          <p style={{ color: "red", marginTop: "1rem" }}>{error}</p>
        ) : (
          <BuildView cohort={cohort} />
        )}
      </>
    </MainContainer>
  );
}

